export default "__VITE_ASSET__fiD8DrGr__"